import * as React from 'react';
import { useState } from 'react'

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import Typography from '@mui/material/Typography';
import Tooltip from "@mui/material/Tooltip";
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from 'axios';

import { Lang, useFormInputValidation } from "react-form-input-validation";
import "./Form.css";

import LocationPicker from './LocationPicker';

const theme = createTheme();

export default function Salons(props) {
  // const { spId, spSalonId, setSpSalonId, onClose } = props
  const { spId, setShowSalon, onClose } = props
  // console.log('sln props', props)

  const [spSalonId, setSpSalonId] = useState(null);

  const MAX_SIZE_MB = 10;
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [address1, setAddress1] = useState("")
  const [address2, setAddress2] = useState("")
  const [pincode, setPincode] = useState("")
  const [city, setCity] = useState("")
  const [salontype, setSalontype] = useState("")
  const [landline, setLandline] = useState("")
  const [mobile, setMobile] = useState("")
  const [gstin, setGstin] = useState("")
  const [pan, setPan] = useState("")
  const [chairs, setChairs] = useState("1")
  const [salonsBtn, setSalonsBtn] = useState(false)
  const [holiday, setHoliday] = useState(1)
  const [opens, setOpens] = useState(0)
  const [closes, setCloses] = useState(0)
  const [image, setImage] = useState('')
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [loading, setLoading] = useState(false);

  // console.log("Salon component mounted");


  const onImageChange = (event) => {
    const file = event.target.files[0];
    console.log('file', file.size)
    if (file && file.size > MAX_SIZE_MB * 1024 * 1024) {
      alert("File too large. Maximum allowed size is 10MB.You may reduce the image size using any online image compressor and try again later and upload it going to Edit Salon details");
      return;
    }
    setImage(file)
  }

  const [fields, errors, form] = useFormInputValidation(
    {
      email: "",
      name: "",
      address1: "",
      address2: "",
      pincode: "",
      city: "",
      salontype: "",
      landline: "",
      mobile: "",
      gstin: "",
      pan: "",
      chairs: "",
      opens: "",
      closes: "",
      holiday: "",
      image: ""
    },
    {
      email: "required|email",
      name: "required",
      address1: "required",
      address2: "required",
      pincode: "required|digits:6",
      city: "required",
      salontype: "required",
      landline: "",
      mobile: "required|numeric|digits:10",
      gstin: "optional|length:15",
      pan: "optional|length:10",
      chairs: "required",
      opens: "required",
      closes: "required",
      holiday: "required",
      image: "required"
    },
    { validateOnBlur: true, validateOnChange: false }
  );



  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const isValid = await form.validate(event);
    if (!isValid) {
      alert('Please fix the errors')
      console.log('invalid')
      setLoading(false);
      return;
    }

    const formData = new FormData();
    console.log('spId', spId)
    formData.append('name', fields.name);
    formData.append('email', fields.email);
    formData.append('address1', fields.address1);
    formData.append('address2', fields.address2);
    formData.append('pincode', fields.pincode);
    formData.append('city', fields.city);
    formData.append('salon_type', fields.salontype);
    formData.append('landline', fields.landline);
    formData.append('mobile', fields.mobile);
    formData.append('gstin', fields.gstin);
    formData.append('pan', fields.pan);
    formData.append('chairs', fields.chairs);
    formData.append('user_id', spId);
    formData.append('weekday', fields.holiday);
    formData.append('opens', fields.opens);
    formData.append('closes', fields.closes);
    formData.append('latitude', latitude);
    formData.append('longitude', longitude);
    formData.append('image', image);

    const jwt = localStorage.getItem("token");
    const salonsUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/salons'
      : 'http://localhost:3001/salons';

    try {
      const res = await axios.post(salonsUrl, formData, {
        headers: {
          'Accept': 'application/json',
          'Authorization': ` ${localStorage.getItem("token")} `,
        }
      })
      console.log("Response:", res);

      alert(res.data.message || "Salon created!");
      setSpSalonId(res.data.salon.id);
      localStorage.setItem('spSalonId', res.data.salon.id);
      alert("You can now go to Services menu and add services  for your salon");
      setLoading(false);
      setShowSalon(false);
    } catch (error) {
      console.error("Salon error:", error);
      if (error.response) {
        alert(JSON.stringify(error.response.data));
      } else {
        alert("Unexpected error: " + error.message);
      }
    } finally {
      setLoading(false);
    };






  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <SpaOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Add Your Salon Details
            </Typography>
          </Box>
        </Container>
      </ThemeProvider>

      <form
        className="myForm container"
        // noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Name of the Salon
          <input
            type="text"
            name="name"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.name}
          />
        </label>
        <label className="error">
          {errors.name ? errors.name : ""}
        </label>
        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Email
          <input
            type="email"
            name="email"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.email}
          />
        </label>
        <label className="error">
          {errors.email ? errors.email : ""}
        </label>
        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Address 1
          <input
            type="text"
            name="address1"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.address1}
          />
        </label>
        <label className="error">
          {errors.address1 ? errors.address1 : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Address 2
          <input
            type="text"
            name="address2"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.address2}
          />
        </label>
        <label className="error">
          {errors.address2 ? errors.address2 : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Pincode
          <input
            type="number"
            name="pincode"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.pincode}
          />
        </label>
        <label className="error">
          {errors.pincode ? errors.pincode : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          City
          <input
            type="text"
            name="city"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.city}
          />
        </label>
        <label className="error">
          {errors.city ? errors.city : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '1rem' }}>
          Salon Type
          <select
            type="text"
            name="salontype"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.salontype}
          >
            <option value="">Select </option>
            <option value="WomenOnly">WomenOnly </option>
            <option value="MenOnly">MenOnly</option>
            <option value="Unisex">Unisex</option>
            {/* <option value="2">Other</option> */}

          </select>
        </label>
        <label className="error">
          {errors.salontype ? errors.salontype : ""}
        </label>


        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Land Line (with STD )
          <input
            type="number"
            name="landline"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.landline}
          />
        </label>
        <label className="error">
          {/* {errors.landline ? errors.landline : ""} */}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Mobile
          <input
            type="tel"
            name="mobile"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.mobile}
          />
        </label>
        <label className="error">
          {errors.mobile ? errors.mobile : ""}
        </label>


        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          GST (15 dig)
          <input
            type="text"
            name="gstin"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.gstin}
          />
        </label>
        <label className="error">
          {errors.gstin ? errors.gstin : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          PAN (10 dig)
          <input
            type="text"
            name="pan"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.pan}
          />
        </label>
        <label className="error">
          {errors.pan ? errors.pan : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Chairs
          <input
            type="number"
            name="chairs"
            onBlur={form.handleBlurEvent}
            onChange={form.handleChangeEvent}
            value={fields.chairs}
          />
        </label>
        <label className="error">
          {errors.chairs ? errors.chairs : ""}
        </label>
        <Tooltip title="Enter time in 24 hour format" placement="right" arrow>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>
            Opens
            <input
              type="time"
              name="opens"
              onBlur={form.handleBlurEvent}
              onChange={form.handleChangeEvent}
              value={fields.opens}
            />
          </label>
        </Tooltip>
        <label className="error">
          {errors.opens ? errors.opens : ""}
        </label>
        <Tooltip title="Enter time in 24 hour format" placement="right" arrow>
          <label style={{ display: 'block', marginBottom: '1rem' }}>
            Closes
            <input
              type="time"
              name="closes"
              onBlur={form.handleBlurEvent}
              onChange={form.handleChangeEvent}
              value={fields.closes}
            />
          </label>
        </Tooltip>
        <label className="error">
          {errors.closes ? errors.closes : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Weekly Holiday
          <select
            id="holiday"
            name="holiday"
            value={fields.holiday}
            onChange={form.handleChangeEvent}
            onBlur={form.handleBlurEvent}
          >
            <option value="">Select</option>
            <option value={1}>Sunday</option>
            <option value={2}>Monday</option>
            <option value={3}>Tuesday</option>
            <option value={4}>Wednesday</option>
            <option value={5}>Thursday</option>
            <option value={6}>Friday</option>
            <option value={7}>Saturday</option>
          </select>
        </label>
        <label className="error">
          {errors.holiday ? errors.holiday : ""}
        </label>

        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Location Upload

          <LocationPicker
            latitude={latitude}
            longitude={longitude}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
          />
        </label>

        <label style={{ display: 'block', marginBottom: '1.5rem' }}>
          Salon Image Upload
          <input type="file"
            accept="image/*"
            multiple={false}
            onChange={onImageChange}
          />
        </label>

        {/* <button type="submit"
          disabled={salonsBtn}
        >
          Submit Salon Details</button> */}
        <button type="submit" disabled={loading || salonsBtn}>
          {loading ? "Saving..." : "Submit Salon Details"}
        </button>
        {/* <button
          type="button"
          onClick={setShowSalon(false)}
          style={{ marginTop: '1.5rem' }}
        >
          Exit
        </button> */}
      </form >
    </>
  );

}
